var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { ref: "swiperCarousel", staticClass: "col-12 home-list__inner" },
      [
        _c("div", { staticClass: "swiper-container list-item-carousel" }, [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.$slots.items, function(item, index) {
              return _c(
                "div",
                { staticClass: "swiper-slide" },
                [_c("slot-component", { key: index, attrs: { vnode: item } })],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-pagination" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "swiper-button-prev" }),
        _vm._v(" "),
        _c("div", { staticClass: "swiper-button-next" })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }